var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 29",
    clipPath: "url(#clip0_462_2885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9261 3.68245C16.7705 2.22467 15.6192 1.07311 14.1613 0.917651C10.5052 0.52745 6.8385 0.52745 3.18258 0.917651C1.72467 1.07324 0.573236 2.22467 0.417651 3.68245C0.0274497 7.33837 0.0274497 11.0052 0.417651 14.6612C0.573236 16.1191 1.72467 17.2705 3.18245 17.4261C6.83837 17.8163 10.5052 17.8163 14.1613 17.4261C15.6192 17.2705 16.7705 16.1191 16.9261 14.6612C17.3163 11.0052 17.3163 7.3385 16.9261 3.68245Z",
    fill: "url(#paint0_radial_462_2885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.30078 7.09961C3.33638 6.84817 3.36351 6.5953 3.40876 6.34569C3.66529 4.93186 4.66622 3.96992 6.0974 3.92062C7.82057 3.86141 9.54896 3.85828 11.2719 3.92036C12.8295 3.97644 13.9576 5.12983 14.0063 6.68802C14.0581 8.3426 14.0581 10.0012 14.0063 11.6558C13.9576 13.214 12.8299 14.3672 11.272 14.4235C9.54909 14.4857 7.82031 14.4872 6.09753 14.4225C4.53959 14.364 3.46263 13.208 3.35842 11.6474C3.34943 11.5125 3.32047 11.3787 3.30078 11.2443C3.30078 9.86271 3.30078 8.4811 3.30078 7.09961ZM8.6744 13.5C9.46288 13.5 10.2522 13.5236 11.0396 13.4945C12.2742 13.4487 13.0336 12.7119 13.0625 11.4784C13.0982 9.94148 13.0982 8.40246 13.0625 6.86539C13.0336 5.63219 12.2737 4.87813 11.0396 4.85191C9.47319 4.81879 7.90508 4.81905 6.33867 4.85191C5.11394 4.87761 4.35232 5.61641 4.31906 6.83605C4.27681 8.39242 4.27681 9.95153 4.31906 11.5079C4.35232 12.7274 5.11394 13.4491 6.3388 13.4945C7.11633 13.5235 7.89582 13.5 8.6744 13.5Z",
    fill: "url(#paint1_linear_462_2885)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.30078 7.09961C3.33638 6.84817 3.36351 6.5953 3.40876 6.34569C3.66529 4.93186 4.66622 3.96992 6.0974 3.92062C7.82057 3.86141 9.54896 3.85828 11.2719 3.92036C12.8295 3.97644 13.9576 5.12983 14.0063 6.68802C14.0581 8.3426 14.0581 10.0012 14.0063 11.6558C13.9576 13.214 12.8299 14.3672 11.272 14.4235C9.54909 14.4857 7.82031 14.4872 6.09753 14.4225C4.53959 14.364 3.46263 13.208 3.35842 11.6474C3.34943 11.5125 3.32047 11.3787 3.30078 11.2443C3.30078 9.86271 3.30078 8.4811 3.30078 7.09961ZM8.6744 13.5C9.46288 13.5 10.2522 13.5236 11.0396 13.4945C12.2742 13.4487 13.0336 12.7119 13.0625 11.4784C13.0982 9.94148 13.0982 8.40246 13.0625 6.86539C13.0336 5.63219 12.2737 4.87813 11.0396 4.85191C9.47319 4.81879 7.90508 4.81905 6.33867 4.85191C5.11394 4.87761 4.35232 5.61641 4.31906 6.83605C4.27681 8.39242 4.27681 9.95153 4.31906 11.5079C4.35232 12.7274 5.11394 13.4491 6.3388 13.4945C7.11633 13.5235 7.89582 13.5 8.6744 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.67152 6.4375C7.15949 6.4375 5.93359 7.66327 5.93359 9.1753C5.93359 10.6875 7.15949 11.9132 8.67152 11.9132C10.1837 11.9132 11.4095 10.6875 11.4095 9.1753C11.4095 7.66327 10.1837 6.4375 8.67152 6.4375ZM8.67152 10.9706C7.67998 10.9706 6.87623 10.1668 6.87623 9.1753C6.87623 8.18376 7.67998 7.38001 8.67152 7.38001C9.66307 7.38001 10.4668 8.18376 10.4668 9.1753C10.4668 10.1668 9.66307 10.9706 8.67152 10.9706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.2207 6.30767C12.2207 6.66736 11.9291 6.95896 11.5694 6.95896C11.2097 6.95896 10.918 6.66736 10.918 6.30767C10.918 5.94786 11.2097 5.65625 11.5694 5.65625C11.9291 5.65625 12.2207 5.94786 12.2207 6.30767Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_462_2885",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.62912 15.5636) scale(18.8514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544,
    stopColor: "#FADC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1167,
    stopColor: "#FBCE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#FCB720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    stopColor: "#FE9838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3054,
    stopColor: "#FF7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FF1C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_2885",
    x1: 12.0669,
    y1: 5.80247,
    x2: 5.15214,
    y2: 12.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0922,
    stopColor: "#9C3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2927,
    stopColor: "#DC2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#FD1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#FC6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6887,
    stopColor: "#FC9B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7521,
    stopColor: "#FCAF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7806,
    stopColor: "#FDB750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#FECB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#FFD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0938,
    height: 17.0938,
    fill: "white",
    transform: "translate(0.125 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta3);
export default __webpack_public_path__ + "static/media/Insta3.22724632ffd2a5429d155c6b49d9e7f4.svg";
export { ForwardRef as ReactComponent };